var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamsuitcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 5.5C1.5 5.5 1.5 5.08579 1.79289 4.79289C1.79289 4.79289 2.08579 4.5 2.5 4.5H13.5C13.5 4.5 13.9142 4.5 14.2071 4.79289C14.2071 4.79289 14.5 5.08579 14.5 5.5V13.5C14.5 13.5 14.5 13.9142 14.2071 14.2071C14.2071 14.2071 13.9142 14.5 13.5 14.5H2.5C2.5 14.5 2.08579 14.5 1.79289 14.2071C1.79289 14.2071 1.5 13.9142 1.5 13.5V5.5ZM2.5 5.5V13.5H13.5V5.5H2.5Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43934 2.93934C5 3.37868 5 4 5 4V5C5 5.27614 5.22386 5.5 5.5 5.5C5.77614 5.5 6 5.27614 6 5V4C6 3.79289 6.14645 3.64645 6.14645 3.64645C6.29289 3.5 6.5 3.5 6.5 3.5H9.5C9.70711 3.5 9.85355 3.64645 9.85355 3.64645C10 3.79289 10 4 10 4V5C10 5.27614 10.2239 5.5 10.5 5.5C10.7761 5.5 11 5.27614 11 5V4C11 3.37868 10.5607 2.93934 10.5607 2.93934C10.1213 2.5 9.5 2.5 9.5 2.5H6.5C5.87868 2.5 5.43934 2.93934 5.43934 2.93934Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H14C14.2761 11 14.5 10.7761 14.5 10.5C14.5 10.2239 14.2761 10 14 10H2C1.72386 10 1.5 10.2239 1.5 10.5C1.5 10.7761 1.72386 11 2 11Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsuitcase);
export default __webpack_public_path__ + "static/media/teamsuitcase.85bc7c5e3378836c895b285d4933c191.svg";
export { ForwardRef as ReactComponent };